import React from "react"

/** Banknote glyph for price-related actions; matches the 18px #4A5353 icon set. */
const CurrencyIcon = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="4" width="16" height="10" rx="1.5" stroke="#4A5353" strokeWidth="1.3" />
            <circle cx="9" cy="9" r="2.4" stroke="#4A5353" strokeWidth="1.3" />
            <circle cx="4.2" cy="9" r="0.9" fill="#4A5353" />
            <circle cx="13.8" cy="9" r="0.9" fill="#4A5353" />
        </svg>
    )
}
export default CurrencyIcon
